import { ref, reactive, onBeforeMount } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import { tagsReport } from "@/@fake-db/mock-tags/mockTagsReport";

export default function useTagsReport() {
  const loading = reactive({
    tableData: false,
  });
  const fields = [
    { key: "seq", label: "No."},
    { key: "ref", label: "Reference" },
    { key: "tag_name", label: "Tag Name" , sortable : true},
    { key: "content_type", label: "Content Type" },
    { key: "content_name", label: "Content Name" },
    { key: "latest_update", label: "Latest Update" , sortable : true },
  ];


  const tagsReportTable = reactive({
    payload: [],
  });

  const fetchTagsReportList = () => {
    tagsReportTable.payload = tagsReport;
  };

  onBeforeMount(() => {
    fetchTagsReportList();
  });

  return {
    fields,
    loading,
    tagsReportTable,
  };
}
